import React, {useState} from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "../../../components/Modal";
import CustomButton from "../../../components/CustomButton";
import RadioButton from "../../../components/RadioButton";
import {VisionStatementInterface} from "../interfaces";


interface Props {
  save: Function;
  close: () => void;
  type: string;
  t: Function;
  lang: string;
  visionStatement: VisionStatementInterface
}

const UpdateProgress = (props: Props) => {
  const [step, setStep] = useState(props.type === "done" ? 2 : 1);
  const [progress, setProgress] = useState(props.type === "done" ? 100 : props.visionStatement.progress);
  const [development, setDevelopment] = useState(0);
  const [effort, setEffort] = useState(0);
  const [onTrack, setOnTrack] = useState(0);

  const percentages = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

  const renderStep1 = () => {
    return (
      <>
        <div className="text-gray-300 mt-2">
          {
            props.lang === "sv" ? "Hur mycket av målbilden har du uppnått?" :
              "How much progress have you made toward this Goal?"
          }
        </div>

        <div className="text-gray-300 font-medium mt-4">
          {
            props.lang === "sv" ? "Andel uppnådd" :
              "Percentage achieved"
          }
        </div>

        <div className="mt-2">
          <select className="z-select z-800" value={progress}
                  onChange={(e) => setProgress(parseInt(e.target.value))}>
            {
              percentages.map(percentage => (
                <option key={"percent_" + percentage} value={percentage}>{percentage}%</option>
              ))
            }
          </select>
        </div>
      </>
    )
  }

  const renderStep2 = () => {
    if (progress === 100) {
      return (
        <>
          <div className="mt-2 text-gray-300">
            {
              props.lang === "sv" ? "Ta en stund att reflektera över din målbild." :
                "Take moment to reflect on your Goal."
            }
          </div>

          <div className="mt-4 text-gray-300">
            {
              props.lang === "sv" ? "Känner du att du har utvecklats på något sätt, till exempel genom nya insikter, färdigheter eller beteenden?" :
                "Have you noticed any personal development while working on it — such as new insights, skills, or behaviours?"
            }
          </div>

          <div className="mt-3">
            <RadioButton name="development1" label={props.lang === "sv" ? "Ja, mycket" : "Yes, significant"}
                         id="development1" value="1" checked={development === 1} onChange={() => setDevelopment(1)}/>
          </div>

          <div className="mt-3">
            <RadioButton name="development2" label={props.lang === "sv" ? "Ja, lite grann" : "Yes, to some extent"}
                         id="development2" value="2" checked={development === 2} onChange={() => setDevelopment(2)}/>
          </div>
          <div className="mt-3">
            <RadioButton name="development3" label={props.lang === "sv" ? "Nej, inte än" : "Not really"}
                         id="development3" value="3" checked={development === 3} onChange={() => setDevelopment(3)}/>
          </div>

          <div className="mt-4 text-gray-300">
            {
              props.lang === "sv" ? "Hur skulle du beskriva ditt engagemang för målbilden?" :
                "How would you describe your level of effort during this process?"
            }
          </div>

          <div className="mt-3">
            <RadioButton name="effort1" label={props.lang === "sv" ? "Väldigt engagerad" : "Highly engaged"}
                         id="effort1" value="1" checked={effort === 1} onChange={() => setEffort(1)}/>
          </div>

          <div className="mt-3">
            <RadioButton name="effort2" label={props.lang === "sv" ? "Balanserat" : "Generally engaged"}
                         id="effort2" value="2" checked={effort === 2} onChange={() => setEffort(2)}/>
          </div>
          <div className="mt-3">
            <RadioButton name="effort3" label={props.lang === "sv" ? "Mindre engagerad än jag tänkt" : "Less engaged than intended"}
                         id="effort3" value="3" checked={effort === 3} onChange={() => setEffort(3)}/>
          </div>
        </>
      )
    } else {
      return (
        <>
          <div className="mt-2 font-medium">
            {
              props.lang === "sv" ? "Hur ligger du till?" : "Are you on track?"
            }
          </div>

          <div className="mt-3">
            <RadioButton name="ontrack1" label={props.lang === "sv" ? "I fas" : "On track"}
                         id="ontrack1" value="1" checked={onTrack === 1} onChange={() => setOnTrack(1)}/>
          </div>

          <div className="mt-3">
            <RadioButton name="ontrack2" label={props.lang === "sv" ? "Något efter" : "Slightly behind"}
                         id="ontrack2" value="2" checked={onTrack === 2} onChange={() => setOnTrack(2)}/>
          </div>
          <div className="mt-3">
            <RadioButton name="ontrack3" label={props.lang === "sv" ? "Mycket efter" : "Significantly behind"}
                         id="ontrack3" value="3" checked={onTrack === 3} onChange={() => setOnTrack(3)}/>
          </div>

        </>
      )
    }
  }

  const step2Inactive = () => {
    if (progress === 100) {
      return development === 0 || effort === 0
    } else {
      return onTrack === 0
    }
  }

  const saveFirst = () => {
    if (progress === 100) {
      setStep(2);
    } else {
      props.save(progress, development, effort, onTrack);
    }
  }

  return (
    <Modal isOpen={true} onClose={() => props.close()}>
      <ModalHeader onClose={props.close}>
        {props.type === "done" ? props.t("mark-as-complete") : props.t("update-progress")}
        {props.type === "done" && "?"}
      </ModalHeader>
      <ModalBody>

        {
          step === 1 && renderStep1()
        }
        {
          step === 2 && renderStep2()
        }

      </ModalBody>
      <ModalFooter>
        {
          step === 1 &&
            <CustomButton onClick={() => saveFirst()}
                          buttonType="blueBase">{props.lang === "sv" ? "Uppdatera" : "Update"}</CustomButton>
        }
        {
          step === 2 &&
            <CustomButton disabled={step2Inactive()}
                          onClick={() => props.save(progress, development, effort, onTrack)}
                          buttonType="blueBase">
              {progress === 100 ? props.t("mark-as-complete") : props.t("save")}
            </CustomButton>
        }
      </ModalFooter>
    </Modal>
  )

}

export default UpdateProgress;